
import axios from 'axios';
import _ from "lodash";
import {  API_EVENT_URL, API_GATEWAY_URL }  from "../config/constants";

interface Exhibitor {
  id: string;

}

export const getExhibitorsByEventId = async (eventId: string) => {
  try {
    const response = await axios.get(`${API_EVENT_URL}api/v1/frontend/events/${eventId}/exhibitors`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return _.get(response, 'data.data', [])
  } catch (err: any) {
    console.error("Error fetching events:", err);
  } 
};



export const fetchExhibitorsCount = async (eventId: string): Promise<Exhibitor[]> => {
  try {
   const response = await axios.get(API_GATEWAY_URL + `frontend/api/events/${eventId}/exhibitors`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

   return _.get(response, 'data.data', []).length;
  } catch (error) {
    console.error("Error fetching exhibitors:", error);
    return [];
  }
};
